class MobileSubmenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-mega-menu-content]");
    this.menuContent = this.closest(".header__mobile-menu-content");
    this.menuContentInner = this.closest(".header__mobile-menu-content-inner");

    this.summary.addEventListener("click", (e) => {
      if (e.target.closest("a")) return;

      e.preventDefault();
      this._toggle();
    });

    this.closeButton = this.querySelector("[data-menu-close]");
    this.closeButton.addEventListener("click", () => this._close());

    document.addEventListener("mobile-menu:closed", () => {
      this.details.open = false;
      this.details.classList.remove("open");
      this.menuContent.classList.remove("submenu-open");
      window.removeTrapFocus(this.summary, this.content);
      this.menuContentInner.removeEventListener("transitionend", this.onEnd);
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.details.classList.contains("open")) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _open() {
    this.menuContent.style.overflow = "hidden";
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.details.classList.add("open");
      this.menuContent.classList.add("submenu-open");

      this.onEnd = () => {
        this.menuContentInner.removeEventListener("transitionend", this.onEnd);
        if (!this.details.classList.contains("open")) return;

        window.trapFocus(this.content, this.closeButton);
        this.dispatchEvent(
          new CustomEvent("mobile-submenu:open", { bubbles: true }),
        );
        this.menuContent.style.overflow = null;
      };

      this.menuContentInner.addEventListener("transitionend", this.onEnd);
    });
  }

  _close() {
    this.menuContent.style.overflow = "hidden";
    this.details.classList.remove("open");
    this.menuContent.classList.remove("submenu-open");

    this.onEnd = () => {
      this.menuContentInner.removeEventListener("transitionend", this.onEnd);

      if (this.details.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary, this.content);
      this.dispatchEvent(
        new CustomEvent("mobile-submenu:close", { bubbles: true }),
      );
      this.menuContent.style.overflow = null;
    };
    this.menuContentInner.addEventListener("transitionend", this.onEnd);
  }
}

if (!customElements.get("mobile-submenu")) {
  customElements.define("mobile-submenu", MobileSubmenu);
}
